/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_SuccessInputs */

const en_feedback_success = /** @type {(inputs: Feedback_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you! Your feedback has been sent.`)
};

const de_feedback_success = /** @type {(inputs: Feedback_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vielen Dank! Ihr Feedback wurde gesendet.`)
};

const fr_feedback_success = /** @type {(inputs: Feedback_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci ! Votre commentaire a été envoyé.`)
};

const es_feedback_success = /** @type {(inputs: Feedback_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias! Sus comentarios han sido enviados.`)
};

const it_feedback_success = /** @type {(inputs: Feedback_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie! Il tuo feedback è stato inviato.`)
};

const nl_feedback_success = /** @type {(inputs: Feedback_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedankt! Uw feedback is verzonden.`)
};

const pl_feedback_success = /** @type {(inputs: Feedback_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziękujemy! Twoja opinia została wysłana.`)
};

const fi_feedback_success = /** @type {(inputs: Feedback_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiitos! Palautteesi on lähetetty.`)
};

const da_feedback_success = /** @type {(inputs: Feedback_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak! Din feedback er sendt.`)
};

const sv_feedback_success = /** @type {(inputs: Feedback_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tack! Din feedback har skickats.`)
};

/**
* | output |
* | --- |
* | "Thank you! Your feedback has been sent." |
*
* @param {Feedback_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const feedback_success = /** @type {((inputs?: Feedback_SuccessInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_SuccessInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_feedback_success(inputs)
	if (locale === "fr") return fr_feedback_success(inputs)
	if (locale === "es") return es_feedback_success(inputs)
	if (locale === "it") return it_feedback_success(inputs)
	if (locale === "nl") return nl_feedback_success(inputs)
	if (locale === "pl") return pl_feedback_success(inputs)
	if (locale === "fi") return fi_feedback_success(inputs)
	if (locale === "da") return da_feedback_success(inputs)
	if (locale === "sv") return sv_feedback_success(inputs)
	return en_feedback_success(inputs)
});